"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 -9 58 58",
    fill: "none",
    width: props.size || props.width || "24px",
    id: "discover",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "#fff",
    stroke: "#F3F3F3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.069 20.322c0 2.443 1.918 4.336 4.385 4.336.698 0 1.295-.137 2.032-.484v-1.908c-.648.649-1.222.91-1.956.91-1.633 0-2.791-1.183-2.791-2.866 0-1.595 1.195-2.853 2.715-2.853.773 0 1.358.276 2.032.935v-1.907c-.711-.36-1.296-.51-1.994-.51-2.455 0-4.423 1.932-4.423 4.347m-4.159-2.017c0 .449.285.686 1.258 1.046 1.843.674 2.39 1.271 2.39 2.592 0 1.608-1.182 2.728-2.866 2.728-1.233 0-2.13-.486-2.876-1.582l1.047-1.008c.373.721.995 1.108 1.768 1.108.724 0 1.259-.499 1.259-1.172 0-.349-.163-.648-.486-.86-.163-.1-.486-.249-1.12-.473-1.523-.548-2.045-1.134-2.045-2.278 0-1.36 1.121-2.38 2.592-2.38.91 0 1.744.31 2.441.92l-.848 1.11c-.422-.473-.821-.672-1.307-.672-.698 0-1.207.397-1.207.92m-4.325 6.166h1.62v-8.308h-1.62zm-3.313-2.067c-.51.46-1.17.66-2.218.66H4.62V17.57h.435c1.047 0 1.683.188 2.218.672.56.499.898 1.273.898 2.068 0 .798-.338 1.595-.898 2.094M5.38 16.163H3v8.308h2.366c1.259 0 2.167-.297 2.965-.96a4.17 4.17 0 001.508-3.188c0-2.453-1.832-4.16-4.46-4.16m30.741 0l2.216 5.58 2.244-5.58h1.757l-3.59 8.521h-.872l-3.525-8.521zm6.95 8.308h4.596v-1.407h-2.977v-2.242h2.867v-1.408H44.69V17.57h2.977v-1.408H43.07zm7.288-4.484h.473c1.035 0 1.584-.45 1.584-1.284 0-.809-.549-1.232-1.558-1.232h-.5zm.784-3.825c1.869 0 2.94.898 2.94 2.453 0 1.272-.672 2.108-1.892 2.356l2.615 3.5h-1.993l-2.243-3.338h-.211v3.338h-1.62v-8.309z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.159 22.727a4.42 4.42 0 10-7.447-4.762 4.42 4.42 0 107.447 4.762",
    fill: "url(#discover__a)"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "discover__a",
    x1: 36.54,
    y1: 19.003,
    x2: 29.093,
    y2: 14.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#F6A000"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 0.624,
    stopColor: "#E47E02"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: 1,
    stopColor: "#D36002"
  }))));
};
var _default = exports["default"] = SvgComponent;